function r(){for(var r="",t="ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",a=0;a<32;a++)r+=t.charAt(Math.floor(48*Math.random()));return r}export{r as csrfToken};
